import * as yup from 'yup'
import { FieldValues, Resolver } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { isValidFirebaseEmail } from '../../../../../../pure-js/libs/emailValidation'
import { InviteUsersFormValues } from './InviteUserRow'

export type TranslateFn = (key: string, options?: Record<string, unknown>) => string

export const defaultFormValues: InviteUsersFormValues = {
  name: '',
  email: ''
}

export const createValidationSchema = (t: TranslateFn) =>
  yup
    .object({
      name: yup.string().trim().required(t('facilitator.profile.inviteUsers.validation.nameRequired')),
      email: yup
        .string()
        .trim()
        .email(t('facilitator.profile.inviteUsers.validation.emailInvalid'))
        .test(
          'firebase-email',
          t('facilitator.profile.inviteUsers.validation.emailInvalid'),
          (value) => !value || isValidFirebaseEmail(value)
        )
        .required(t('facilitator.profile.inviteUsers.validation.emailRequired'))
    })
    .required() as yup.ObjectSchema<Record<string, unknown>>

export const buildResolver = <TFieldValues extends FieldValues>(schema: yup.AnyObjectSchema) =>
  yupResolver(schema as never) as unknown as Resolver<TFieldValues>
